var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.247,
    height: 273.965,
    viewBox: "0 0 297.247 273.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ade0d9;}.b{fill:#fff;}.c{fill:#07274a;}.d{fill:#50b89d;}.e{fill:#176385;}.f{fill:#f8cdba;}.g{fill:#1f161e;}.h{fill:none;stroke:#1f161e;stroke-linecap:round;stroke-miterlimit:10;}.i{fill:#fa9e9f;}.j{fill:#969696;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.95)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 136.031,
    cy: 136.031,
    r: 136.031,
    transform: "translate(43.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.5,168.433c0-5.128,12.734-6.216,17.763-6.216,10.207,0,10.886-5.842,19.358-5.842,7.447,0,11.238,6.029,18.178,6.029,14.895,0,18.21-17.144,32.693-17.144,14.733,0,13.983,17.9,27.7,17.9,6.972,0,48.858,1.32,48.858,5.279Z",
    transform: "translate(-61.549 -94.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M660,230.976c0-3.241,11.037-8.313,17.073-8.313,11.907,0,8.19,4.157,15.68,4.157,8.535,0,10.485-18.509,23.472-18.509,14.194,0,11.966,18.1,20.677,18.1,3.752,0,5.631-1.76,10.967-1.76,3.09,0,6.476,3.09,6.476,6.335Z",
    transform: "translate(-435.147 -134.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M660,230.976c0-3.241,11.037-8.313,17.073-8.313,11.907,0,8.19,4.157,15.68,4.157,8.535,0,10.485-18.509,23.472-18.509,14.194,0,11.966,18.1,20.677,18.1,3.752,0,5.631-1.76,10.967-1.76,3.09,0,6.476,3.09,6.476,6.335Z",
    transform: "translate(-638.05 -50.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M660,225.115c0-2.4,8.183-6.164,12.659-6.164,8.828,0,6.072,3.082,11.625,3.082,6.328,0,7.774-13.723,17.4-13.723,10.524,0,8.872,13.421,15.331,13.421,2.782,0,4.175-1.3,8.131-1.3a5.15,5.15,0,0,1,4.8,4.7Z",
    transform: "translate(-422.95 -10.375)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.481 58.267)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 99.551,
    height: 50.496,
    transform: "translate(13.391 165.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M314.66,490.37c.432,2.574,7.773,61.42,8.963,62.393s13.817,3.13,14.9,1.514c.216-2.574.515-43.613,1.184-47.284",
    transform: "translate(-152.674 -348.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M37.6,433.574c-5.091-2.507,5.524,47.191,33.462,47.191s74.964-42.558,82.578-42.558c16.808,0,56.6,33,59.716,33,2.389-2.389,7.166-6.569,7.166-8.237s-38.095-64.349-66.6-64.349C142.87,398.635,49.1,439.253,37.6,433.574Z",
    transform: "translate(-17.645 -304.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.321,460.717c5.585-1.266,12.535-4.546,18.687-7.9-16.736,5.472-30.45,9.009-34.409,7.053-2.7-1.328-.988,11.974,5.354,24.787C41.8,482.184,40.168,463.723,53.321,460.717Z",
    transform: "translate(-17.644 -330.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M49.2,298.791c4.4.118,27.315-.556,33.6,5.426,4.659,4.438,19.145,42.6,21.379,56-9.73,4.947-79.906,38.548-101.625,23.773C2.066,372.509,4.3,326.873,18.5,302.94,23.693,299.481,44.964,298.683,49.2,298.791Z",
    transform: "translate(-1.206 -255.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M97.945,277.59H84.56v14.383c0,3.6,13.385,3.573,13.385,0Z",
    transform: "translate(-41.028 -245.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M84.56,285.231c0-1.6,4.422-5.606,7.156-5.462.067-1.776-6.244-4.329-6.244-4.329L84.56,277.9Z",
    transform: "translate(-41.028 -244.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M103.282,255.479a20.1,20.1,0,0,0,.453-4.237c0-10.615-8.293-19.222-18.533-19.222S66.67,240.627,66.67,251.242a20.1,20.1,0,0,0,.453,4.237Z",
    transform: "translate(-32.348 -223.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M103.841,249.31c-2.27-.345-4.535-2.131-6.116-3.3-9.009,6.6-14.78,6.687-15.4,6.687s-3.161,3.645-4.329,4.057l-.1-.062a14.054,14.054,0,1,0,27.011-7.377A4.3,4.3,0,0,1,103.841,249.31Z",
    transform: "translate(-37.792 -230.268)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.467,
    cy: 5.467,
    r: 5.467,
    transform: "translate(37.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M85.833,258.43a2.3,2.3,0,0,0,0,4.6",
    transform: "translate(-40.582 -236.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M121.94,259c.674.9,2.409,2.481,0,4.154",
    transform: "translate(-59.165 -236.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M107.75,269.41a2.753,2.753,0,0,0,1.735,2.7",
    transform: "translate(-52.28 -241.622)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 2.121,
    cy: 1.102,
    rx: 2.121,
    ry: 1.102,
    transform: "translate(48.865 25.745)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 2.121,
    cy: 1.102,
    rx: 2.121,
    ry: 1.102,
    transform: "translate(64.633 25.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M157.54,372.6l14.306-3.681c1.374,2.337,8.067,25.3,8.067,25.3l-22.085,9.307C158.117,399.18,158.987,379.257,157.54,372.6Z",
    transform: "translate(-76.438 -289.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M57.917,369.08c0,1.73-1.457,8.314-2.317,11.408",
    transform: "translate(-26.976 -289.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M152.077,351.426c-.345-2.723-2.363-18.069-5.8-26.146",
    transform: "translate(-70.975 -268.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M157.54,372.6l14.306-3.681c1.374,2.337,8.067,25.3,8.067,25.3l-22.085,9.307C158.117,399.18,158.987,379.257,157.54,372.6Z",
    transform: "translate(-76.438 -289.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M381,531.36c.319.515,4.582,5.745,6.09,5.8s10.667-6.147,10.265-7.48-6.147-.463-7.135-.932a10.9,10.9,0,0,1-3.557-3.65",
    transform: "translate(-184.863 -365.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M337.006,612.1c-.108.571-.69,7.31.355,8.4s11.943,2.986,12.576,1.745-4.118-4.6-4.484-5.621a10.821,10.821,0,0,1,0-5.086",
    transform: "translate(-163.391 -407.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M258.368,392.044H209.89l11.542-30.584H269.91Z",
    transform: "translate(-101.839 -286.285)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 48.478,
    height: 1.153,
    transform: "translate(67.655 104.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M28.621,386.043c-.932,3.48-5.457,18.409-3.614,20.983s48-3.259,60.349-7.1c3.145-1.03,5.477-3.727,6.872-4.077a7.366,7.366,0,0,1,8.319,5.261C95.617,403.495,24.41,439.85,1.337,423.67c-4.36-3.125,3.29-41.219,3.64-43.14C8.874,381,28.621,386.043,28.621,386.043Z",
    transform: "translate(0.002 -295.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M158.82,415.152c1.39-.329,2.6-.654,3.6-.963,3.145-1.03,5.477-3.727,6.872-4.077a7.366,7.366,0,0,1,8.319,5.261",
    transform: "translate(-77.06 -309.84)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.5a418fd1.svg";
export { ForwardRef as ReactComponent };